import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ProfileSetup.EmailPage', {
    pageTitle: 'Profile Setup',

    partnerStatusXeroPlatinum: 'Xero Platinum',
    partnerStatusXeroGold: 'Xero Gold',
    partnerStatusXeroOther: 'Xero Other',
    partnerStatusQBOPlatinum: 'QuickBooks Online Platinum',
    partnerStatusQBOElite: 'QuickBooks Online Elite',
    partnerStatusQBOOther: 'QuickBooks Online Other',
    partnerStatusOracleNetSuite: 'Oracle NetSuite',
    partnerStatusHybrid: 'Hybrid',
    partnerStatusOther: 'Other',

    productInterestXero: 'Xero',
    productInterestQuickBooksOnline: 'QuickBooks Online',
    productInterestOracleNetSuite: 'Oracle NetSuite',
    productInterestCin7Core: 'Cin7 Core',
    productInterestHybrid: 'Hybrid',
    productInterestOther: 'Other',

    numberOfEntitiesLess3: 'Less than 3',
    numberOfEntitiesBeetween3_10: '3 - 10',
    numberOfEntitiesMore10: '10+',

    numberOfClientsBeetween1_10: '1 - 10',
    numberOfClientsBeetween10_50: '10 - 50',
    numberOfClientsMore50: '50+',

    useCaseStreamlineAuditProcesses: 'Streamline audit processes',
    useCaseEstablishInternalFinancialControls: 'Establish internal financial controls',
    useCaseAutomateApprovalWorkflows: 'Automate approval workflows',
    useCaseSpeedupTheApprovalProcess: 'Speed up the approval process',
    useCaseOther: 'Other',
});
